import { JBP_PLANNING_WIZARD_TRANSLATION_PREFIX, TPlanningWizardTranslationPrefix } from '../config'

export const getTranslationNamespace = (
  module: string
): `${TPlanningWizardTranslationPrefix}-${string}` => {
  return `${JBP_PLANNING_WIZARD_TRANSLATION_PREFIX}${module}`
}
